// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__r-P4w","text":"SelectPayment_text__3RRSy","title":"SelectPayment_title__1C2dY","btn":"SelectPayment_btn__1sgTx"};